import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import YoutubePostPreview from './youtube-post-preview.component';
import YoutubeShortsPreview from './youtube-shorts-preview.component';

const YoutubePreviewOrganize = ({ postType, previewData, profileId }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!previewData || !profileId) return;
    let data = previewData[profileId].data;
    for (var i = 0; i < data.length; i++) {
      if (data[i].post_type === postType) {
        data[i].media_data = CommonHelper.ProcessMediaUrl(data[i].media_url);
        setData(data[i]);
      }
    }
  }, [postType, previewData, profileId]);

  return (
    <>
      {data && data?.post_type === 'video' && <YoutubePostPreview data={data} />}
      {data && data?.post_type === 'shorts' && <YoutubeShortsPreview data={data} />}
    </>
  );
};

export default YoutubePreviewOrganize;

